module.exports = __webpack_public_path__ + "static/img/Josh_Kelly_mobile.cdfdd93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh_Kelly_mobile.jpg
// module id = WVte
// module chunks = 0